import { render, staticRenderFns } from "./document-center.vue?vue&type=template&id=4e54cb7c&scoped=true&"
import script from "./document-center.vue?vue&type=script&lang=js&"
export * from "./document-center.vue?vue&type=script&lang=js&"
import style0 from "./document-center.vue?vue&type=style&index=0&id=4e54cb7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54cb7c",
  null
  
)

export default component.exports